module.exports = __webpack_public_path__ + "img/Buisness_Registration_Number.4884e234.svg";